<template>
  <el-dialog :title="dialogOption.title" :visible.sync="dialogOption.visible" width="500px"
              :close-on-click-modal="false" :before-close="beforeClose" :append-to-body="true">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" @submit.native.prevent @keyup.enter.native="submitForm">
      <el-form-item label="目录名称" prop="name">
        <el-input v-model="ruleForm.name" class="worker-input" ref="rule_form_name" :class="{'is-error':ruleForm.ruleNoAllow,'is-success':!ruleForm.ruleNoAllow&&ruleForm.name}" @blur="checkRule"></el-input>
        <span style="color: red;" v-show="ruleForm.ruleNoAllow">{{ruleForm.ruleNoAllow}}</span>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="ruleForm.remark" type="textarea" :rows="2"></el-input>
      </el-form-item>
      <el-form-item label="对外公开" v-if='categoryId == Category.ProdDir'>
        <el-checkbox v-model="ruleForm.checked"></el-checkbox>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size='mini' @click="close">取消</el-button>
      <el-button type="primary" size="mini" :loading="loading" @click="submitForm">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {WinForm} from '@digital-supply-chain/module'
  //引入组件
  import {MessageBox} from "element-ui";
  import { Message, TreeService } from '@/service';
  import { Category, DomainService} from '@/libs';

  export default {
    name: "tree-edit",
    props: ["activeTreeNode","categoryId"],
    data() {
      return {
        Category,
        ruleForm: {
          name: "",
          remark: "",
          checked:true,
          ruleNoAllow:"",
        },
        loading: false,
        rules: {//表单规则
          remark: [
            {max: 200, message: '备注最多200个字符', trigger: 'blur'},
          ],
        },
        dialogOption: {//dialog参数
          title: "",
          visible: false,//是否展示dialog
          type:"",//当前的type
        },
      }
    },
    methods: {
      btnHandler(btn) {
        switch (btn.type) {
          case "modify"://修改
            this.ruleForm.name = this.activeTreeNode.DirName;
            this.ruleForm.remark = this.activeTreeNode.DirRemark;
            this.ruleForm.checked = this.activeTreeNode.ShareArea == 5;
          case "add"://添加
            this.$set(this.dialogOption, "visible", true);
            this.$set(this.dialogOption, "title", btn.name);
            this.$set(this.dialogOption, "type", btn.type);
            this.$nextTick(() => {
              this.$refs.rule_form_name.focus();
            })
            break;
          case "grant"://授权
            let auth_name = this.activeTreeNode.DirName;
            let categoryId = this.categoryId;
            let auth_datas = [{"CategoryID": categoryId,"DataID":this.activeTreeNode.DirID,"Title":this.activeTreeNode.DirName}];
            WinForm.md.openWindow(
              `${DomainService.Web}/user/auth-control?categoryId=${categoryId}&type=multi&auth_datas=${encodeURIComponent(JSON.stringify(auth_datas))}&auth_name=${auth_name}`,
              900,
              500
            );
            break;
          case "del":
            let confirmText = "您确定要删除吗？";
            if(this.activeTreeNode.DataCount > 0) {
              confirmText = "该目录下有数据，您确定要删除吗？"
            }
            MessageBox.confirm(confirmText, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              TreeService.del(this.categoryId,[this.activeTreeNode.DirID]).then(res=>{
                if(!res){
                  Message.error('删除失败!');
                  return;
                }
                this.clearRuleForm();
                this.$emit("del-success",this.activeTreeNode);
                Message.success('删除成功');
              });
            }).catch(() => {
            });
            break;
          default:
        }
      },
      submitForm(e) {
        if(!this.checkRule())return;
        if(this.loading) return;
        this.loading = true;
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            let ShareArea = this.ruleForm.checked ? 5 : 0;
            this.$set(this.dialogOption, "visible", false);
            this.dialogOption.type=="add"&&TreeService.insert(this.categoryId,this.activeTreeNode.DirID,this.ruleForm.name,this.ruleForm.remark,ShareArea).then(res=>{
              const pid =this.activeTreeNode.DirID;
              this.$emit("insert-success",{CategoryID:this.categoryId,DirID:res,DirName:this.ruleForm.name,DirRemark:this.ruleForm.remark,pid,ParentID:pid,ShareArea});
              this.loading = false;
              this.clearRuleForm();
              Message.success('新增成功');
            }).catch(res=>{
              this.loading = false;
            });;
            this.dialogOption.type=="modify"&&TreeService.modify(this.activeTreeNode.DirID,this.categoryId,this.activeTreeNode.pid,this.ruleForm.name,this.ruleForm.remark,ShareArea).then(res=>{
              this.$emit("modify-success",{CategoryID:this.categoryId,DirID:this.activeTreeNode.DirID,DirName:this.ruleForm.name,DirRemark:this.ruleForm.remark,pid:this.activeTreeNode.pid,ShareArea});
              this.clearRuleForm();
              this.loading = false;
              Message.success('修改成功');
            }).catch(res=>{
              this.loading = false;
            });;
          };
        });
      },
      clearRuleForm(){
        this.ruleForm.ruleNoAllow=""
        this.ruleForm.name = "";
        this.ruleForm.remark = "";
        this.ruleForm.checked = true;
      },
      close() {
        this.dialogOption.visible = false;
        this.$refs['ruleForm'].clearValidate();
        this.clearRuleForm();
      },
      beforeClose(done) {
        this.$refs['ruleForm'].clearValidate();
        this.clearRuleForm();
        done();
      },
      checkRule(){
        if(!this.ruleForm.name){
          this.ruleForm.ruleNoAllow="请输入目录名称";
        }else  if(this.ruleForm.name.length>50){
          this.ruleForm.ruleNoAllow="名称最多50个字符"
        }else{
          this.ruleForm.ruleNoAllow="";
        };
        return this.ruleForm.name&&this.ruleForm.name.length<50;
      }
    }
  }
</script>

<style scoped lang="less">

</style>